import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {i18nMixin} from '@aofl/i18n-mixin';
import {sdoNs, modals, studentDetailSections, products, lessonDetailSections} from '@modules/constants-enumerate';
import './sdo';
import {SimpleModal} from '@modules/simple-modal';
import translations from '@modules/i18n';

/**
 * @summary StudentStatusList
 * @extends {AoflElement}
 */
@customElement('student-status-list')
class StudentStatusList extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of StudentStatusList.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
  }
  /**
   * @readonly
   */
  static is = 'student-status-list';

  @property({type: Array, mapState: `${sdoNs.STUDENT_STATUS_LIST}.collapsesByStatus`, store: storeInstance})
  collapsesByStatus = {};

  @property({type: Array})
  students = [];

  @property({type: String})
  status = '';

  @property({type: String})
  header = '';

  @property({type: String})
  bubbleTextColor = '#FFFFFF';

  toggleCollapse(_status) {
    storeInstance.commit({
      mutationId: 'toggleCollapse',
      namespace: sdoNs.STUDENT_STATUS_LIST,
      payload: _status
    });
  }

  openStudentDashboard(e) {
    e.cancelBubble = true;
    const student = e.detail.student;
    const state = storeInstance.getState();
    const academyLessonModalData = state[sdoNs.SIMPLE_MODAL].modals[modals.ACADEMY_LESSON_DETAILS_MODAL].data;
    SimpleModal.show(modals.STUDENT_DETAILS, {
      first_name: student.first_name,
      last_name: student.last_name,
      id: parseInt(student.id, 10),
      activeSection: studentDetailSections.DASHBOARD,
      activeDashTab: products.READING_MASTERY,
      onClose: (e) => {
        SimpleModal.show(modals.ACADEMY_LESSON_DETAILS_MODAL, academyLessonModalData, e);
      }
    }, e);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default StudentStatusList;
